var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfile/MemberProfileSettingsInner.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfile/MemberProfileSettingsInner.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"MemberProfileSettingsInner ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"public")) {
t_5 += " MemberProfileSettingsInner--private";
;
}
t_5 += "\">\n        <div class=\"MemberProfileSettingsInner-name\">\n            Profile Settings\n        </div>\n        <form class=\"MemberProfileSettingsInner-form\">\n            <input type=\"radio\" id=\"public\" name=\"private\"\n                   class=\"MemberProfileSettingsInner-form-input";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"public")) {
t_5 += " active";
;
}
t_5 += "\"\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"public")) {
t_5 += " checked";
;
}
t_5 += " value=\"0\">\n            <label class=\"MemberProfileSettingsInner-form-label\" for=\"public\">\n                <div class=\"MemberProfileSettingsInner-form-labelIcon\"></div>\n                <div class=\"MemberProfileSettingsInner-form-labelName\">Public Profile</div>\n            </label>\n            <input type=\"radio\" id=\"private\" name=\"private\"\n                   class=\"MemberProfileSettingsInner-form-input";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"public")) {
t_5 += " active";
;
}
t_5 += "\"\n                    ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"public")) {
t_5 += " checked";
;
}
t_5 += " value=\"1\">\n            <label class=\"MemberProfileSettingsInner-form-label\" for=\"private\">\n                <div class=\"MemberProfileSettingsInner-form-labelIcon\"></div>\n                <div class=\"MemberProfileSettingsInner-form-labelName\">Private Profile</div>\n            </label>\n        </form>\n        <div class=\"MemberProfileSettingsInner-btnPasswordWrapper\">\n            <div class=\"MemberProfileSettingsInner-btnPassword\">Change Password</div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MemberProfileSettingsInner");
context.setVariable("MemberProfileSettingsInner", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfile/MemberProfileSettingsInner.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfileSettingsInner.jinja
// module id = 51
// module chunks = 0